"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typed_json_rpc_1 = require("@hediet/typed-json-rpc");
exports.uiContract = typed_json_rpc_1.contract({
    client: {},
    server: {
        getSchema: typed_json_rpc_1.requestContract({
            result: typed_json_rpc_1.types.any,
        }),
        run: typed_json_rpc_1.notificationContract({
            params: typed_json_rpc_1.types.type({
                args: typed_json_rpc_1.types.any,
            }),
        }),
    },
});
//# sourceMappingURL=uiContract.js.map